<head>
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
    integrity="sha512-iecdLmaskl7CVkqkXNQ/ZH/XLlvWZOJyj7Yy7tcenmpD1ypASozpmT/E0iPtmFIB46ZmdtAc9eNBvH0H/ZpiBw=="
    crossorigin="anonymous" referrerpolicy="no-referrer" />
</head>

<div class="d-flex justify-content-between">
  <div>
    <app-breadcrumb></app-breadcrumb>
  </div>
  <div class="d-flex gap-4 align-items-top">
    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" *ngIf="message.isAuditTrailUser"
      (click)="openAuditTrail()" (keydown.enter)="openAuditTrail()">
      <i class="fa-solid fa-clipboard" style="font-size:18px;color:white"></i>
      <span class="reload_text text-white">Audit Trail</span>
    </div>
    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (keydown.enter)="openReport('Excel')" (click)="openReport('Excel')">
      <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
      <span class="reload_text text-white">Excel Report</span>
    </div>
    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (keydown.enter)="openReport('Pdf')" (click)="openReport('Pdf')">
      <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
      <span class="reload_text text-white">PDF Report</span>
    </div>
    <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center"
      (keydown.enter)="refreshForm()" (click)="refreshForm()">
      <img src="../../../assets/img/cr_module/reload.svg" width="18px" height="18px" alt="reload" />
      <span class="reload_text">Reload</span>
    </div>
  </div>
</div>

<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>


<div class="dataEmpty">
  <div class="row" *ngIf="isTmsSettingsDataEmpty">The form presently lacks any content</div>
</div>

<div class="form form-content">
  <div class="row">
    <div class="col-md-2">
      <div><label for="email">E-signature at Training Unlock?</label></div>
      <mat-slide-toggle color="primary" name="esignatureAtTrainingUnlock"
        [(ngModel)]="tmsSettingsObj.esignatureAtTrainingUnlock">
        <ng-container *ngIf="tmsSettingsObj.esignatureAtTrainingUnlock; else NoEsignatureAtTrainingUnlock">
          <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
        </ng-container>
        <ng-template #NoEsignatureAtTrainingUnlock>
          <span style="color: red;">No</span>
        </ng-template>
      </mat-slide-toggle>
    </div>
    <div class="col-md-2">
      <div><label for="email">E-signature at Training Completion?</label></div>
      <mat-slide-toggle color="primary" name="esignatureAtTrainingCompletion"
        [(ngModel)]="tmsSettingsObj.esignatureAtTrainingCompletion">
        <ng-container *ngIf="tmsSettingsObj.esignatureAtTrainingCompletion; else NoEsignatureAtTrainingCompletion">
          <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
        </ng-container>
        <ng-template #NoEsignatureAtTrainingCompletion>
          <span style="color: red;">No</span>
        </ng-template>
      </mat-slide-toggle>
    </div>
    <div class="col-md-4">
      <div><label for="email">Mark Training Completed For Document Action Performers?</label></div>
      <mat-slide-toggle color="primary" name="esignatureAtTrainingUnlock"
        [(ngModel)]="tmsSettingsObj.markTrainingCompletedForDocumentActionPerformers">
        <ng-container *ngIf="tmsSettingsObj.markTrainingCompletedForDocumentActionPerformers; else no">
          <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
        </ng-container>
        <ng-template #no>
          <span style="color: red;">No</span>
        </ng-template>
      </mat-slide-toggle>
    </div>
    <div class="col-md-4">
      <div><label for="email">Reports Timezone</label></div>
      <mat-select matInput placeholder="Select" [ngClass]="{'odd-item-mat-select': oddTimezone == selectedTimeZone}"
        [(ngModel)]="selectedTimeZone" (closed)="reportsTimezonesearchTxt=''"
        (click)="focusmethod('reportsTimezonefocusSearch')" (keydown.enter)="focusmethod('reportsTimezonefocusSearch')">
        <input type="search" id="reportsTimezonefocusSearch" class="dropdownsearchstyle"
          [(ngModel)]="reportsTimezonesearchTxt" matInput placeholder="Search">
        <mat-option class="unselectStyle" [value]="null"
          (onSelectionChange)="onReportsTimezoneSelect($event,null);">Un-select</mat-option>
        <mat-option *ngFor="let item of timeZoneDropdown | assessmentSearch :reportsTimezonesearchTxt"
          (onSelectionChange)="onReportsTimezoneSelect($event,item)" [value]="item.valueExp">
          {{ item.displayExp }}
        </mat-option>
      </mat-select>
    </div>
  </div>
  <div class="row">
    <div class="col-md-4">
      <div><label for="email">No. of Allowed Trainings <span class="ancillary-label">(In Days)</span></label></div>
      <input class="input-filed-continers" type="number" (keydown)="validateNumberFields($event)"
        [(ngModel)]="tmsSettingsObj.noOfAllowedTrainingsInADay">
    </div>
    <div class="col-md-4">
      <div><label for="email">Training Content Extensions</label></div>
      <mat-select matInput multiple placeholder="Select" #reasonForChange
        [(ngModel)]="tmsSettingsObj.selectedAllowedFileExtns" (closed)="allowedFileExtnsSearchText=''"
        (click)="focusSearch('focusSearch')" (keydown.enter)="focusSearch('focusSearch')">
        <input type="search" id="focusSearch" class="dropdownsearchstyle" [(ngModel)]="allowedFileExtnsSearchText"
          matInput placeholder="search">
        <div class="select-all">
          <mat-checkbox [(ngModel)]="allSelected" (change)="toggleAllSelection('reasonForChange')">Select
            All</mat-checkbox>
        </div>
        <mat-option *ngFor="let item1 of allowedFileExtnList| multiAssessmentSearchPipe :allowedFileExtnsSearchText"
          [value]="item1.valueExp">
          {{ item1.displayExp }}
        </mat-option>
      </mat-select>
    </div>
  </div>

  <div class="button-continer" mat-dialog-actions>
    <button mat-stroked-button class="addButton" (click)="saveTmsSettings(tmsSettingsObj)">
      <i class="fa fa-save"></i> Save
    </button>
  </div>
</div>

<app-static-audit-trail #auditTrailPopup></app-static-audit-trail>
<app-excel-pdf #excelPdfPopup [excelPdf]="excelPdf"></app-excel-pdf>